import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService} from 'ngx-alerts';
import {DashboardService} from '../../../../services/dashboard.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {PageEvent} from '@angular/material/paginator';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'app-driving-alerts',
  templateUrl: './driving-alerts.component.html',
  styleUrls: ['./driving-alerts.component.scss']
})
export class DrivingAlertsComponent implements OnInit {
  drivingAlerts: any[] = [];
  name: string = '';
  search = {
    tripId: '',
    vehicleId: '',
    userId: '',
    size: 10,
    page: 0
  };

  totalRecords = 0;
  pageEvent: PageEvent;

  constructor(private router: Router, private route: ActivatedRoute, private alertService: AlertService,
              public dashboardService: DashboardService, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
    let params = this.route.snapshot.queryParams;
    this.name = params['name'];
    if (params['vehicleId']) {
      this.search.vehicleId = params['vehicleId'];
    }
    if (params['tripId']) {
      this.search.tripId = params['tripId'];
    }
    if (params['userId']) {
      this.search.userId = params['userId'];
    }
    this.getDrivingAlerts();
  }

  private getDrivingAlerts() {
    this.spinner.show();
    this.dashboardService.getDrivingAlerts(this.search).pipe(finalize(() => this.spinner.hide())).subscribe(
      (res: any) => {
        this.drivingAlerts = res.drivingAlerts;
        if (this.drivingAlerts && this.drivingAlerts.length) {
          this.drivingAlerts.forEach(da => {
            da['alertData'] = JSON.parse(da.data);
          });
          console.log(JSON.stringify(this.drivingAlerts[0]));
        }
        this.totalRecords = res.totalRecords;
      }, error1 => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );
  }

  getServerData(ev: PageEvent) {
    this.search.page = ev.pageIndex;
    this.search.size = ev.pageSize;
    this.getDrivingAlerts();
    return ev;
  }

  getVehicleName(item: any) {
    if (item && item.userVehicle) {
      return (item.userVehicle.vehicleBrand + ' ' + item.userVehicle.vehicleModel + ' ' + item.userVehicle.regNumber);
    } else {
      return '';
    }
  }
}
